export const deg2rad = (d) => (d * Math.PI) / 180;
export const snap = (v, s) => Math.round(v / s) * s;

export const toShop = (sx, sy, ox, oy, scale) => ({
  x: (sx - ox) / scale,
  y: (sy - oy) / scale,
});

export const itemAABB = (item) => {
  const hw = (item.fw * item.scaleX) / 2;
  const hh = (item.fh * item.scaleY) / 2;
  const r = deg2rad(item.rot);
  const cos = Math.abs(Math.cos(r));
  const sin = Math.abs(Math.sin(r));
  const W = hw * cos + hh * sin;
  const H = hw * sin + hh * cos;
  return { x: item.cx - W, y: item.cy - H, w: W * 2, h: H * 2 };
};

export const aabbOverlap = (a, b) => {
  const aa = itemAABB(a),
    ab = itemAABB(b);
  return !(
    aa.x + aa.w <= ab.x ||
    ab.x + ab.w <= aa.x ||
    aa.y + aa.h <= ab.y ||
    ab.y + ab.h <= aa.y
  );
};

export const itemInBounds = (item, shopW, shopH) => {
  const bb = itemAABB(item);
  return bb.x >= 0 && bb.y >= 0 && bb.x + bb.w <= shopW && bb.y + bb.h <= shopH;
};

export const uid = () => `${Date.now()}-${Math.random().toString(36).slice(2)}`;
